import { adminUsersByIdLinksPasswordResetPostSlice } from './post';
import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';

export const adminUsersByIdLinksPasswordResetSendReducers = combineReducers({
	post: adminUsersByIdLinksPasswordResetPostSlice.asyncReducers
});

export const adminUsersByIdLinksPasswordResetSendWatchers = combineAllWatchers([
	adminUsersByIdLinksPasswordResetPostSlice.asyncWatchers
]);
